import React from 'react';

export default function Credibility() {
  return (
    <section className="py-24 px-6 relative">
      <div className="liquid-glass max-w-3xl mx-auto rounded-3xl p-8 md:p-12 text-center">
        <p className="text-xs tracking-widest uppercase text-white/50 font-sans mb-6">
          THE PERSON BEHIND THE WORK
        </p>
        <h2 className="font-instrument italic text-3xl md:text-5xl text-white leading-tight">
          "I spent over a decade learning exactly what makes a product sell on camera. HSN taught me that. Hollywood sharpened it."
        </h2>
        
        <div className="font-sans text-base text-white/70 max-w-2xl mx-auto mt-10 space-y-6 text-left md:text-center leading-relaxed">
          <p>
            I started at HSN in 2013 — not behind a camera, but in front of the data. My job was to watch live sales numbers while the broadcast was running and tell the producer exactly what to show next. When a specific shot caused a sales spike, I caught it in real time and called the adjustment. I learned early that the right frame at the right moment isn't art — it's revenue.
          </p>
          <p>
            From there I moved through every layer of live broadcast production — visual coordinator, special projects lead working directly with Tyra Banks, Nicki Minaj, Keith Urban, Shaquille O'Neal, and others — then stage manager running the entire floor, then production coordinator on HSN's own brand campaigns.
          </p>
          <p>
            After HSN I relocated to Los Angeles, working on union productions for New Balance, Dior, Verizon, McDonald's, Disney, Paramount, Netflix, and NBC Universal.
          </p>
          <p>
            Now based in Sacramento, what I bring to your Amazon listing isn't just cinematography. It's over a decade of understanding the exact relationship between what's on screen and what makes someone buy.
          </p>
        </div>
      </div>
    </section>
  );
}